import { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import debounce from 'lodash/debounce';
import Carousel, { CarouselItem } from 'src/components/Carousel';

import theme from 'src/styles/components/MenuCategories.module.scss';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import LinesEllipsis from 'react-lines-ellipsis';

const Menu = ({ categories, setActiveCategory, enableAutoUpdateMenuCategory, multipleMenus }) => {
    const handleEnableAutoUpdateMenuCategory = useCallback(debounce(() => {
        enableAutoUpdateMenuCategory();
    }, 1000, []));

    const handleSetCategory = useCallback((id) => {
        setActiveCategory(id, true, true);
        handleEnableAutoUpdateMenuCategory();
    }, [multipleMenus]);

    const currentCategoryIndex = categories.findIndex((category) => category.isActive);

    const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

    return (
        <div className={theme.container}>
            <div className={theme.contentContainer}>
                <Carousel
                  isInitialized
                  isPrevButtonEnabled={false}
                  isNextButtonEnabled={false}
                  shouldSlideByStaticWidth={false}
                  areIndicatorsEnabled={false}
                  isInfinite={false}
                  currentSlide={currentCategoryIndex > 0 ? currentCategoryIndex : null}
                  noItemsTranslationKey=""
                  role="group"
                >
                    {categories.map(({ name, isActive, id }) => (
                        <CarouselItem key={id}>
                            <div
                              onClick={() => handleSetCategory(id)}
                              className={classnames(theme.category, { [theme.active]: isActive })}
                              role="menuitem"
                              tabIndex={0}
                            >
                                <div className={classnames(theme.categoryName, { [theme.active]: isActive })}>
                                    <ResponsiveEllipsis
                                      text={name}
                                      maxLine="2"
                                      ellipsis="..."
                                      trimRight
                                      basedOn="letters"
                                    />
                                </div>
                            </div>
                        </CarouselItem>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

Menu.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired
    })),
    setActiveCategory: PropTypes.func.isRequired,
    enableAutoUpdateMenuCategory: PropTypes.func.isRequired,
    multipleMenus: PropTypes.bool
};

export default Menu;
